import API from '../../../../API/API'
import { asArray, asText, authHeaders } from '../Shared/apiHelpers'

/**
 * Path segments used by GET /Connection/{connectorId}/salesPersonCode/{source}
 * Source -> ERP system, Target -> eCommerce system.
 */
export const ERP_SEGMENT = 'Source'
export const ECOMMERCE_SEGMENT = 'Target'

/**
 * Normalises an API sales person ({ salesPersonCode, salesPersonId, type }) into the
 * shared select's { value, label } shape, carrying the id along for the save payload.
 * Entries without a code are dropped and codes are de-duplicated, since the code is
 * what users pick by.
 */
const toOptions = (data) => {
    const seen = {}
    return asArray(data)
        .map((salesPerson) => {
            const code = asText(salesPerson.salesPersonCode)
            return { value: code, label: code, id: asText(salesPerson.salesPersonId) }
        })
        .filter((option) => {
            if (option.value === '' || seen[option.value]) {
                return false
            }
            seen[option.value] = true
            return true
        })
}

export const getSalesPersons = (connectorId, segment, config) =>
    API.get(`/Connection/${connectorId}/salesPersonCode/${segment}`, { headers: authHeaders(), ...config })
        .then((response) => toOptions(response.data))

export const getSalesPersonMappings = (connectorId, config) =>
    API.get(`/Connection/${connectorId}/salesPerson-mappings`, { headers: authHeaders(), ...config })
        .then((response) => asArray(response.data).map((mapping) => ({
            erpSalesPersonId: asText(mapping.erpSalesPersonId),
            erpSalesPersonCode: asText(mapping.erpSalesPersonCode),
            ecommerceSalesPersonId: asText(mapping.ecommerceSalesPersonId),
            ecommerceSalesPersonCode: asText(mapping.ecommerceSalesPersonCode)
        })))

/** Payload shape expected by POST /Connection/{connectorId}/salesPerson-mappings. */
const toRequestBody = (mapping) => ({
    ecommerceSalesPersonCode: mapping.ecommerceSalesPersonCode,
    erpSalesPersonId: mapping.erpSalesPersonId,
    erpSalesPersonCode: mapping.erpSalesPersonCode,
    ecommerceSalesPersonId: mapping.ecommerceSalesPersonId
})

/** Responds with { result, message, id }; the caller reads `result`. */
export const saveSalesPersonMappings = (connectorId, mappings) =>
    API.post(
        `/Connection/${connectorId}/salesPerson-mappings`,
        mappings.map(toRequestBody),
        { headers: authHeaders() }
    ).then((response) => response.data)
